var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeco12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 654,
    height: 654,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-923 -2129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.5 2456C1104.72 2456 1250 2310.72 1250 2131.5L1250 2131.5C1250 2310.72 1395.28 2456 1574.5 2456L1574.5 2456C1395.28 2456 1250 2601.28 1250 2780.5L1250 2780.5C1250 2601.28 1104.72 2456 925.5 2456Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#9142FF",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco12);
export default __webpack_public_path__ + "static/media/deco12.516c5b363f538e30d2ce0c36ac5989e4.svg";
export { ForwardRef as ReactComponent };